import React from 'react';
import LandingHeader from '@components/Index/LandingHeader';
import MobileMenu from '@components/Index/MobileMenu';
import classnames from 'classnames';
// @ts-ignore
import Div100vh from 'react-div-100vh';
import { useLandingMenu } from './hooks/useLandingMenu';
import LandingHeaderAuthButtons from '@components/Index/LandingHeader/LandingHeaderAuthButtons';

type Props = {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  contentClassName?: string;
};

const LandingStaticLayout: React.FC<Props> = ({
  children,
  sidebar,
  contentClassName = 'max-w-876px',
}) => {
  const { ref: menuRef, shown: menuShown, setShown: setMenuShown } = useLandingMenu();
  return (
    <>
      <div className="flex flex-row w-screen divide-x divide-neutral-50 relative">
        <MobileMenu
          ref={menuRef}
          className={classnames({
            'opacity-0 pointer-events-none': !menuShown,
          })}
        />
        <div className="flex-grow flex flex-col relative">
          <LandingHeader
            className="flex-shrink-0 sticky top-0 left-0 bg-white z-100 w-full overflow-hidden"
            menuShown={menuShown}
            onMenuShow={() => setMenuShown(true)}
            onMenuHide={() => setMenuShown(false)}
            showAuthButtons={!sidebar}
          />
          <div className="flex-grow flex flex-col">
            <div
              className={classnames(
                'pl-6 pr-6 md:pl-10 md:pr-10 lg:pl-40 py-10 flex-grow flex flex-col',
                contentClassName,
              )}
            >
              {children}
            </div>
          </div>
        </div>
        {sidebar && (
          <div className="hidden lg:flex flex-shrink-0 flex flex-col w-330px relative">
            <div className="px-10 py-5 sticky top-0 left-0 right-0 bg-white z-30">
              <LandingHeaderAuthButtons />
            </div>
            <div className="sticky bottom-0 flex flex-col items-stretch">
              <div className="py-10 px-6">{sidebar}</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default LandingStaticLayout;
